module.exports = __webpack_public_path__ + "media/images/help/company/mv-company-05-55c91bfc67c41934f146e9655bcf1ced.jpg";